import React from 'react';
import { inject, observer } from 'mobx-react';
import { List, SimpleListItem } from '@rmwc/list';
import { SimpleMenuSurface } from '@rmwc/menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { areaGuidesPath } from '../../api/paths/cms';

@inject('headerState')
@observer
class DesktopNav extends React.PureComponent {
  render() {
    const { hideLeadLinks } = this.props.headerState;

    return (
      <div className="nav-menu-container ml-4">
        <SimpleMenuSurface
          handle={
            <a className="home-menu-link font-semibold mx-2">
              Reviews <FontAwesomeIcon icon={['far', 'chevron-down']} />
            </a>
          }
          anchorCorner="bottomLeft"
        >
          <List>
            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/members/sign_up/neighborhood?utm_source=pcsgrades&utm_medium=website&utm_content=nav_neighborhood"
              text="Off-Base Neighborhoods"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/members/sign_up/on_base_housing?utm_source=pcsgrades&utm_medium=website&utm_content=nav_on_base_housing"
              text="On Base Housing"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/members/sign_up/apartment?utm_source=pcsgrades&utm_medium=website&utm_content=nav_apartment"
              text="Apartments"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/members/sign_up/moving_company?utm_source=pcsgrades&utm_medium=website&utm_content=nav_moving_company"
              text="Moving Companies"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/members/sign_up/realtor?utm_source=pcsgrades&utm_medium=website&utm_content=nav_realtor"
              text="Real Estate Agents"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/members/sign_up/lender?utm_source=pcsgrades&utm_medium=website&utm_content=nav_lender"
              text="Mortgage Lenders"
            />
          </List>
        </SimpleMenuSurface>

        <SimpleMenuSurface
          handle={
            <a className="home-menu-link font-semibold mx-2">
              Moving Resources{' '}
              <FontAwesomeIcon icon={['far', 'chevron-down']} />
            </a>
          }
          anchorCorner="bottomLeft"
        >
          <List>
            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="https://www.pcsgrades.com/cms/?utm_source=pcsgrades&utm_medium=website&utm_content=nav-moving-resources"
              text="Blog"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/bah-calculator?utm_source=pcsgrades&utm_medium=website&utm_content=nav-bah-calc"
              text="BAH Calculator"
            />

            <SimpleListItem
              tag="a"
              href={`${areaGuidesPath}?utm_source=pcsgrades&utm_medium=website&utm_content=nav-area-guides`}
              text="Area Guides"
            />

            <SimpleListItem
              tag="a"
              href="/lost-during-my-pcs?utm_source=pcsgrades&utm_medium=website&utm_content=nav-lost-during-my-pcs"
              text="Lost During My PCS"
            />
          </List>
        </SimpleMenuSurface>

        {!hideLeadLinks && (
          <>
            <a
              href="/home-loans?utm_source=pcsgrades&utm_medium=website&utm_content=nav-connect-with-lender"
              className="home-menu-link fs-sm font-semibold mx-2"
            >
              Find a Lender
            </a>

            <a
              href="/real-estate-rewards?utm_source=pcsgrades&utm_medium=website&utm_content=nav-find-an-agent"
              className="home-menu-link find-an-agent-link fs-sm font-semibold mx-2"
            >
              Find a REALTOR&reg;
            </a>
          </>
        )}

        <SimpleMenuSurface
          handle={
            <a className="home-menu-link font-semibold mx-2">
              About Us <FontAwesomeIcon icon={['far', 'chevron-down']} />
            </a>
          }
          anchorCorner="bottomLeft"
        >
          <List>
            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/about-us?utm_source=pcsgrades&utm_medium=website&utm_content=nav-about-us"
              text="Our Team"
            />

            <SimpleListItem
              tag="a"
              className="no-wrap"
              href="/contact-us?utm_source=pcsgrades&utm_medium=website&utm_content=nav-contact-us"
              text="Contact Us"
            />

            <SimpleListItem
              tag="a"
              href="/faqs?utm_source=pcsgrades&utm_medium=website&utm_content=nav-faqs"
              text="FAQs"
            />
          </List>
        </SimpleMenuSurface>

        <a href="/members/sign_up" className="ui button cornell login ml-auto">
          Join Us
        </a>

        <div className="ml-4">
          <a href="/sign_in" className="ui button outlined blue login">
            Log In
          </a>
        </div>
      </div>
    );
  }
}

export default DesktopNav;
